const rankingItems = [
  { rank: 1, title: '台北娜娜与圈内制作人恋情实锤？多方证据浮出水面', heat: '98.7万', trend: 'up', change: '+12' },
  { rank: 2, title: '玩偶姐姐团队内部矛盾曝光，核心成员疑似出走', heat: '86.3万', trend: 'up', change: '+8' },
  { rank: 3, title: '莫里秀直播言论引发争议，粉丝群体激烈对峙', heat: '72.1万', trend: 'down', change: '-3' },
  { rank: 4, title: '某顶流男星私下约会网红被拍，工作室紧急回应', heat: '65.4万', trend: 'up', change: '+15' },
  { rank: 5, title: '网红圈新一轮互撕大战，涉及多位百万粉丝博主', heat: '58.9万', trend: 'new', change: 'NEW' },
  { rank: 6, title: '娱乐圈税务风波再起，多位艺人被约谈调查', heat: '44.2万', trend: 'up', change: '+6' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新全网最热吃瓜话题，热度数据每分钟刷新
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-100 hover:bg-background-200 rounded-xl transition-colors duration-200 cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-heading text-sm md:text-base shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base text-foreground-950 font-medium truncate group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-fire-line text-accent-500 mr-1"></i>
                  {item.heat}
                </span>
                <span className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' :
                  item.trend === 'new' ? 'text-accent-500' :
                  'text-foreground-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                  {item.change}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}